import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { TypeDocumentDTO } from '../../states';
import { documentTypeState } from '../../states/atoms';
import { BannerStyles } from './Styles';

type Props = {
  margin?: boolean;
  idDocument?: string;
};

export const Banner = ({ margin = true, idDocument }: Props) => {
  const { t } = useTranslation();
  const documentType = useRecoilValue(documentTypeState);

  return (
    <BannerStyles
      fontSize="16"
      negative
      forwardedAs="span"
      $margin={margin}
      id={idDocument}
      testId={idDocument}
    >
      {t(`${TypeDocumentDTO[documentType]}`)}
    </BannerStyles>
  );
};
